module.exports = __webpack_public_path__ + "static/media/wechat-login-bg.c0d8a0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat/wechat-login-bg.png
// module id = 1472
// module chunks = 110